import { DateTime } from 'luxon';
import { createAction } from '@reduxjs/toolkit';

import ActionTypes from './ActionTypes';
import { Greet, GreetSendType, MessageTemplate } from '~/types/models';
import type { Thumbnail } from '@vimily/bonjoro-ui-components-v2/VideoRecorder';

export const init = createAction(ActionTypes.RECORDER_INIT);
export const setThumbnail = createAction<number>(
  ActionTypes.RECORDER_SET_THUMBNAIL
);
export const setMessage = createAction<string>(
  ActionTypes.RECORDER_SET_MESSAGE
);
export const setBlob = createAction<Blob | File | null>(
  ActionTypes.RECORDER_SET_BLOB
);
export const setIsExternalVideo = createAction<boolean>(
  ActionTypes.RECORDER_SET_IS_EXTERNAL_VIDEO
);
export const setDuration = createAction<number | null>(
  ActionTypes.RECORDER_SET_DURATION
);
export const setMessageTemplate = createAction<MessageTemplate | null>(
  ActionTypes.RECORDER_SET_MESSAGE_TEMPLATE
);
export const setSendType = createAction<GreetSendType>(
  ActionTypes.RECORDER_SET_SEND_TYPE
);

export const setManualScheduleDateTime = createAction<DateTime | null>(
  ActionTypes.RECORDER_SET_MANUAL_SCHEDULE_DATE_TIME
);

export const setShowThumbnailSelection = createAction<boolean>(
  ActionTypes.RECORDER_SET_SHOW_THUMBNAIL_SELECTION
);

export const setVideoSourceUrl = createAction<string | null>(
  ActionTypes.RECORDER_SET_VIDEO_SOURCE_URL
);

export const setIsFirstTime = createAction<boolean>('RECORDER_SET_FIRST_TIME');
export const setGreet = createAction<Greet>('RECORDER_SET_GREET');
export const setHasCustomMessage = createAction<boolean>(
  'RECORDER_SET_HAS_CUSTOM_MESSAGE'
);

export const setThumbnails = createAction<Thumbnail[]>(
  ActionTypes.RECORDER_SET_THUMBNAILS
);
